// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var ReactIO = require("../ReactIO.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var TypeUtils = require("./TypeUtils.bs.js");
var Relude_Float = require("relude/src/Relude_Float.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var Relude_Function = require("relude/src/Relude_Function.bs.js");

var include = TypeUtils.MakeOpaqueFloatType({});

var fromFloat = include.fromFloat;

var toFloat = include.toFloat;

function fromFloat$1(param) {
  return Relude_Globals.$great$great(fromFloat, Relude_Option.getOrThrow, param);
}

function add(a, b) {
  var param = Relude_Float.add(Curry._1(toFloat, a), Curry._1(toFloat, b));
  return Relude_Globals.$great$great(fromFloat, Relude_Option.getOrThrow, param);
}

function subtract(a, b) {
  var param = Relude_Float.subtract(Curry._1(toFloat, b), Curry._1(toFloat, a));
  return Relude_Globals.$great$great(fromFloat, Relude_Option.getOrThrow, param);
}

function multiply(a, b) {
  var param = Relude_Float.multiply(Curry._1(toFloat, a), Curry._1(toFloat, b));
  return Relude_Globals.$great$great(fromFloat, Relude_Option.getOrThrow, param);
}

function divide(a, b) {
  var param = Relude_Float.divide(Curry._1(toFloat, b), Curry._1(toFloat, a));
  return Relude_Globals.$great$great(fromFloat, Relude_Option.getOrThrow, param);
}

function addFloat(a) {
  var partial_arg = Relude_Globals.$great$great(fromFloat, Relude_Option.getOrThrow, a);
  return function (param) {
    return add(partial_arg, param);
  };
}

function subtractFloat(a) {
  var partial_arg = Relude_Globals.$great$great(fromFloat, Relude_Option.getOrThrow, a);
  return function (param) {
    return subtract(partial_arg, param);
  };
}

function multiplyWithFloat(a) {
  var partial_arg = Relude_Globals.$great$great(fromFloat, Relude_Option.getOrThrow, a);
  return function (param) {
    return multiply(partial_arg, param);
  };
}

function divideFloat(a) {
  var partial_arg = Relude_Globals.$great$great(fromFloat, Relude_Option.getOrThrow, a);
  return function (param) {
    return divide(partial_arg, param);
  };
}

function toPx(param) {
  return Relude_Globals.$great$great(toFloat, Relude_Float.floorAsInt, param);
}

var Point_fromString = include.fromString;

var Point_toString = include.toString;

var Point_decode = include.decode;

var Point_encode = include.encode;

var Point_compare = include.compare;

var Point_eq = include.eq;

var Point_Ord = include.Ord;

var Point_Set = include.$$Set;

var Point_Map = include.$$Map;

var Point = {
  fromString: Point_fromString,
  toFloat: toFloat,
  toString: Point_toString,
  decode: Point_decode,
  encode: Point_encode,
  compare: Point_compare,
  eq: Point_eq,
  Ord: Point_Ord,
  $$Set: Point_Set,
  $$Map: Point_Map,
  fromFloat: fromFloat$1,
  add: add,
  subtract: subtract,
  multiply: multiply,
  divide: divide,
  addFloat: addFloat,
  subtractFloat: subtractFloat,
  multiplyWithFloat: multiplyWithFloat,
  divideFloat: divideFloat,
  toPx: toPx
};

var Theme = {
  lightBackground: /* LightBackground */0,
  darkBackground: /* DarkBackground */1
};

function toHeight(length) {
  if (length.TAG === /* Square */0) {
    return length._0;
  } else {
    return length.height;
  }
}

function toWidth(length) {
  if (length.TAG === /* Square */0) {
    return length._0;
  } else {
    return length.width;
  }
}

var Box = {
  toHeight: toHeight,
  toWidth: toWidth
};

var Font = {};

var Weight = {};

function point(x) {
  return {
          NAME: "point",
          VAL: x
        };
}

function toPoint(param) {
  return Relude_Globals.$great$great((function (param) {
                switch (param) {
                  case /* XXSmall */0 :
                      return 8.0;
                  case /* XSmall */1 :
                      return 10.0;
                  case /* Small */2 :
                      return 12.0;
                  case /* Medium */3 :
                      return 14.0;
                  case /* Large */4 :
                      return 16.0;
                  case /* XLarge */5 :
                      return 18.0;
                  case /* XXLarge */6 :
                      return 24.0;
                  case /* XXXLarge */7 :
                      return 36.0;
                  case /* XXXXLarge */8 :
                      return 72.0;
                  
                }
              }), fromFloat$1, param);
}

function toLineHeightPoint(param) {
  return Relude_Globals.$great$great((function (param) {
                switch (param) {
                  case /* XXSmall */0 :
                      return 12.0;
                  case /* XSmall */1 :
                  case /* Small */2 :
                      return 16.0;
                  case /* Medium */3 :
                      return 20.0;
                  case /* Large */4 :
                      return 24.0;
                  case /* XLarge */5 :
                      return 28.0;
                  case /* XXLarge */6 :
                      return 36.0;
                  case /* XXXLarge */7 :
                      return 48.0;
                  case /* XXXXLarge */8 :
                      return 84.0;
                  
                }
              }), fromFloat$1, param);
}

var Size = {
  point: point,
  toPoint: toPoint,
  toLineHeightPoint: toLineHeightPoint
};

var Typography = {
  Font: Font,
  Weight: Weight,
  Size: Size
};

var Elevation = {};

var ColorRawValue = {};

var Intensity = {};

var IntensityPartial = {};

var Color = {
  Intensity: Intensity,
  IntensityPartial: IntensityPartial
};

function ColorConverter(C) {
  var toRawValue = function (param) {
    if (typeof param === "number") {
      switch (param) {
        case /* Black */0 :
            return /* Hex */{
                    _0: "000000"
                  };
        case /* CurrentColor */1 :
            return /* Current */0;
        case /* Transparent */2 :
            return /* Transparent */1;
        
      }
    } else {
      switch (param.TAG | 0) {
        case /* Blue */0 :
            switch (param._0) {
              case /* Darkest */0 :
                  return /* Hex */{
                          _0: "09314C"
                        };
              case /* Dark */1 :
                  return /* Hex */{
                          _0: "004679"
                        };
              case /* Medium */2 :
                  return /* Hex */{
                          _0: "2D99D6"
                        };
              case /* Light */3 :
                  return /* Hex */{
                          _0: "A7DBF8"
                        };
              case /* Lightest */4 :
                  return /* Hex */{
                          _0: "E2F1FA"
                        };
              
            }
        case /* Green */1 :
            switch (param._0) {
              case /* Darkest */0 :
                  return /* Hex */{
                          _0: "034224"
                        };
              case /* Dark */1 :
                  return /* Hex */{
                          _0: "659D1D"
                        };
              case /* Medium */2 :
                  return /* Hex */{
                          _0: "91C64D"
                        };
              case /* Light */3 :
                  return /* Hex */{
                          _0: "C0E096"
                        };
              case /* Lightest */4 :
                  return /* Hex */{
                          _0: "EEF5E4"
                        };
              
            }
        case /* Grey */2 :
            switch (param._0) {
              case /* Darkest */0 :
                  return /* Hex */{
                          _0: "1F2A2D"
                        };
              case /* Dark */1 :
                  return /* Hex */{
                          _0: "405961"
                        };
              case /* Medium */2 :
                  return /* Hex */{
                          _0: "7C94A1"
                        };
              case /* Light */3 :
                  return /* Hex */{
                          _0: "C4CED4"
                        };
              case /* Lightest */4 :
                  return /* Hex */{
                          _0: "E7EBEE"
                        };
              
            }
        case /* Orange */3 :
            switch (param._0) {
              case /* Darkest */0 :
                  return /* Hex */{
                          _0: "834104"
                        };
              case /* Dark */1 :
                  return /* Hex */{
                          _0: "C76408"
                        };
              case /* Medium */2 :
                  return /* Hex */{
                          _0: "FA9538"
                        };
              case /* Light */3 :
                  return /* Hex */{
                          _0: "FFCFA3"
                        };
              case /* Lightest */4 :
                  return /* Hex */{
                          _0: "FFF2E5"
                        };
              
            }
        case /* Purple */4 :
            switch (param._0) {
              case /* Darkest */0 :
                  return /* Hex */{
                          _0: "4A0D32"
                        };
              case /* Dark */1 :
                  return /* Hex */{
                          _0: "7E0B50"
                        };
              case /* Medium */2 :
                  return /* Hex */{
                          _0: "D44B8D"
                        };
              case /* Light */3 :
                  return /* Hex */{
                          _0: "F6B6DD"
                        };
              case /* Lightest */4 :
                  return /* Hex */{
                          _0: "FEEAF6"
                        };
              
            }
        case /* Red */5 :
            switch (param._0) {
              case /* Darkest */0 :
                  return /* Hex */{
                          _0: "720C0C"
                        };
              case /* Dark */1 :
                  return /* Hex */{
                          _0: "A00505"
                        };
              case /* Medium */2 :
                  return /* Hex */{
                          _0: "E5383B"
                        };
              case /* Light */3 :
                  return /* Hex */{
                          _0: "FFB4B4"
                        };
              case /* Lightest */4 :
                  return /* Hex */{
                          _0: "FFEBEB"
                        };
              
            }
        case /* Teal */6 :
            switch (param._0) {
              case /* Darkest */0 :
                  return /* Hex */{
                          _0: "05474A"
                        };
              case /* Dark */1 :
                  return /* Hex */{
                          _0: "006E74"
                        };
              case /* Medium */2 :
                  return /* Hex */{
                          _0: "00BAC3"
                        };
              case /* Light */3 :
                  return /* Hex */{
                          _0: "B6ECEE"
                        };
              case /* Lightest */4 :
                  return /* Hex */{
                          _0: "E8FBFC"
                        };
              
            }
        case /* White */7 :
            switch (param._0) {
              case /* Dark */0 :
                  return /* Hex */{
                          _0: "F6F6F6"
                        };
              case /* Medium */1 :
                  return /* Hex */{
                          _0: "F9F9FB"
                        };
              case /* Light */2 :
                  return /* Hex */{
                          _0: "FFFFFF"
                        };
              
            }
        case /* Yellow */8 :
            switch (param._0) {
              case /* Darkest */0 :
                  return /* Hex */{
                          _0: "584012"
                        };
              case /* Dark */1 :
                  return /* Hex */{
                          _0: "DDA30B"
                        };
              case /* Medium */2 :
                  return /* Hex */{
                          _0: "F1C731"
                        };
              case /* Light */3 :
                  return /* Hex */{
                          _0: "FFE6A5"
                        };
              case /* Lightest */4 :
                  return /* Hex */{
                          _0: "FCF5D3"
                        };
              
            }
        
      }
    }
  };
  var toColor = function (param) {
    return Relude_Globals.$great$great(toRawValue, C.rawValueToColor, param);
  };
  return {
          toRawValue: toRawValue,
          toColor: toColor
        };
}

function toPoint$1(param) {
  return Relude_Globals.$great$great((function (param) {
                switch (param) {
                  case /* XSmall */0 :
                      return 12.0;
                  case /* Small */1 :
                      return 16.0;
                  case /* Medium */2 :
                      return 20.0;
                  case /* Large */3 :
                      return 24.0;
                  case /* XLarge */4 :
                      return 36.0;
                  case /* XXLarge */5 :
                      return 48.0;
                  case /* XXXLarge */6 :
                      return 84.0;
                  
                }
              }), fromFloat$1, param);
}

var Size$1 = {
  toPoint: toPoint$1
};

var Availability = {};

function isFullColor(param) {
  return false;
}

var Large = {
  Availability: Availability,
  isFullColor: isFullColor
};

function isFullColor$1(param) {
  return false;
}

var Navigation = {
  isFullColor: isFullColor$1
};

function isFullColor$2(param) {
  return false;
}

var Shift = {
  isFullColor: isFullColor$2
};

function isFullColor$3(param) {
  return false;
}

var Button = {
  isFullColor: isFullColor$3
};

function isFullColor$4(param) {
  return false;
}

var Status = {
  isFullColor: isFullColor$4
};

function isFullColor$5(param) {
  return false;
}

var Messaging = {
  isFullColor: isFullColor$5
};

function isFullColor$6(param) {
  return false;
}

var Social = {
  isFullColor: isFullColor$6
};

function isFullColor$7(param) {
  return false;
}

var Arrow = {
  isFullColor: isFullColor$7
};

function isFullColor$8(param) {
  return false;
}

var Misc = {
  isFullColor: isFullColor$8
};

function isFullColor$9(param) {
  return param === 4;
}

var InputField = {
  isFullColor: isFullColor$9
};

function isFullColor$10(icon) {
  switch (icon.TAG | 0) {
    case /* InputField */2 :
        return icon._0 === 4;
    case /* Arrow */0 :
    case /* Button */1 :
    case /* Messaging */3 :
    case /* Misc */4 :
    case /* Navigation */5 :
    case /* Shift */6 :
    case /* Social */7 :
    case /* Status */8 :
        return false;
    
  }
}

var Small = {
  Navigation: Navigation,
  Shift: Shift,
  Button: Button,
  Status: Status,
  Messaging: Messaging,
  Social: Social,
  Arrow: Arrow,
  Misc: Misc,
  InputField: InputField,
  isFullColor: isFullColor$10
};

function toBoxSize(param) {
  if (param.TAG === /* Large */0) {
    return {
            TAG: /* Square */0,
            _0: Relude_Globals.$great$great(fromFloat, Relude_Option.getOrThrow, 40.0)
          };
  } else {
    return {
            TAG: /* Square */0,
            _0: Relude_Globals.$great$great(fromFloat, Relude_Option.getOrThrow, 24.0)
          };
  }
}

function isFullColor$11(icon) {
  if (icon.TAG === /* Large */0) {
    return false;
  } else {
    return isFullColor$10(icon._0);
  }
}

var Icon = {
  Size: Size$1,
  Large: Large,
  Small: Small,
  toBoxSize: toBoxSize,
  isFullColor: isFullColor$11
};

var $$Blob = {};

var Market = {};

var Social$1 = {};

var Illustration = {
  Market: Market,
  Social: Social$1
};

function toBoxSize$1(param) {
  switch (param) {
    case /* BusinessDark */0 :
    case /* BusinessLight */2 :
        return {
                TAG: /* Rectangle */1,
                height: Relude_Globals.$great$great(fromFloat, Relude_Option.getOrThrow, 23.0),
                width: Relude_Globals.$great$great(fromFloat, Relude_Option.getOrThrow, 160.0)
              };
    case /* BusinessDarkVertical */1 :
    case /* BusinessLightVertical */3 :
        return {
                TAG: /* Rectangle */1,
                height: Relude_Globals.$great$great(fromFloat, Relude_Option.getOrThrow, 117.0),
                width: Relude_Globals.$great$great(fromFloat, Relude_Option.getOrThrow, 219.0)
              };
    case /* I */5 :
        return {
                TAG: /* Square */0,
                _0: Relude_Globals.$great$great(fromFloat, Relude_Option.getOrThrow, 100.0)
              };
    case /* Dark */4 :
    case /* Light */6 :
        return {
                TAG: /* Rectangle */1,
                height: Relude_Globals.$great$great(fromFloat, Relude_Option.getOrThrow, 60.0),
                width: Relude_Globals.$great$great(fromFloat, Relude_Option.getOrThrow, 165.0)
              };
    
  }
}

var Logo = {
  toBoxSize: toBoxSize$1
};

function toBoxSize$2(logo) {
  switch (logo.TAG | 0) {
    case /* Blob */0 :
        return {
                TAG: /* Square */0,
                _0: Relude_Globals.$great$great(fromFloat, Relude_Option.getOrThrow, 375.0)
              };
    case /* Illustration */1 :
        return {
                TAG: /* Square */0,
                _0: Relude_Globals.$great$great(fromFloat, Relude_Option.getOrThrow, 120.0)
              };
    case /* Logo */2 :
        return toBoxSize$1(logo._0);
    
  }
}

var $$Image = {
  $$Blob: $$Blob,
  Illustration: Illustration,
  Logo: Logo,
  toBoxSize: toBoxSize$2
};

var Size$2 = {};

var ActionPriority = {};

var InteractionState = {};

var FocusState = {};

function toBackgroundColor(actionPriority, theme, t) {
  if (!t) {
    if (theme) {
      if (typeof actionPriority === "number") {
        if (actionPriority !== 1) {
          if (actionPriority !== 3 || theme) {
            return /* Transparent */2;
          } else {
            return {
                    TAG: /* White */7,
                    _0: /* Light */2
                  };
          }
        } else if (theme) {
          return /* Transparent */2;
        } else {
          return {
                  TAG: /* White */7,
                  _0: /* Light */2
                };
        }
      } else {
        return /* Transparent */2;
      }
    } else if (typeof actionPriority === "number") {
      if (actionPriority !== 1) {
        if (actionPriority !== 3) {
          return {
                  TAG: /* Grey */2,
                  _0: /* Lightest */4
                };
        } else if (theme) {
          return /* Transparent */2;
        } else {
          return {
                  TAG: /* White */7,
                  _0: /* Light */2
                };
        }
      } else if (theme) {
        return /* Transparent */2;
      } else {
        return {
                TAG: /* White */7,
                _0: /* Light */2
              };
      }
    } else {
      return {
              TAG: /* Grey */2,
              _0: /* Lightest */4
            };
    }
  }
  if (typeof actionPriority !== "number") {
    return actionPriority.backgroundColor;
  }
  switch (actionPriority) {
    case /* Primary */0 :
        return {
                TAG: /* Teal */6,
                _0: /* Medium */2
              };
    case /* LegacySecondary */2 :
        return {
                TAG: /* Grey */2,
                _0: /* Medium */2
              };
    case /* Secondary */1 :
    case /* LegacyTertiary */3 :
        if (theme) {
          return /* Transparent */2;
        } else {
          return {
                  TAG: /* White */7,
                  _0: /* Light */2
                };
        }
    case /* Negative */4 :
        return {
                TAG: /* Red */5,
                _0: /* Medium */2
              };
    
  }
}

function getBorderWidth(param) {
  return Relude_Globals.$great$great((function (param) {
                if (typeof param === "number") {
                  if (param !== 3) {
                    return 1.0;
                  } else {
                    return 2.0;
                  }
                } else {
                  return 1.0;
                }
              }), fromFloat$1, param);
}

function toBorderColor(actionPriority, theme, t) {
  if (!t) {
    if (theme) {
      if (typeof actionPriority === "number" && actionPriority === 3) {
        return {
                TAG: /* Grey */2,
                _0: /* Light */3
              };
      } else {
        return {
                TAG: /* Grey */2,
                _0: /* Medium */2
              };
      }
    } else if (typeof actionPriority === "number" && actionPriority === 3) {
      return {
              TAG: /* Grey */2,
              _0: /* Light */3
            };
    } else {
      return {
              TAG: /* Grey */2,
              _0: /* Lightest */4
            };
    }
  }
  if (typeof actionPriority !== "number") {
    return actionPriority.backgroundColor;
  }
  switch (actionPriority) {
    case /* Primary */0 :
        return {
                TAG: /* Teal */6,
                _0: /* Medium */2
              };
    case /* Secondary */1 :
        return {
                TAG: /* Grey */2,
                _0: /* Light */3
              };
    case /* LegacySecondary */2 :
    case /* LegacyTertiary */3 :
        return {
                TAG: /* Grey */2,
                _0: /* Medium */2
              };
    case /* Negative */4 :
        return {
                TAG: /* Red */5,
                _0: /* Medium */2
              };
    
  }
}

function toTextColor(actionPriority, theme, t) {
  if (!t) {
    if (theme) {
      return {
              TAG: /* Grey */2,
              _0: /* Medium */2
            };
    } else {
      return {
              TAG: /* Grey */2,
              _0: /* Light */3
            };
    }
  }
  if (typeof actionPriority !== "number") {
    return actionPriority.textColor;
  }
  switch (actionPriority) {
    case /* Secondary */1 :
        return {
                TAG: /* Grey */2,
                _0: /* Dark */1
              };
    case /* LegacySecondary */2 :
        return {
                TAG: /* White */7,
                _0: /* Light */2
              };
    case /* LegacyTertiary */3 :
        return {
                TAG: /* Grey */2,
                _0: /* Medium */2
              };
    default:
      return {
              TAG: /* White */7,
              _0: /* Light */2
            };
  }
}

function sizeToFontSize(param) {
  return param + 3 | 0;
}

var Button$1 = {
  Size: Size$2,
  ActionPriority: ActionPriority,
  InteractionState: InteractionState,
  FocusState: FocusState,
  toBackgroundColor: toBackgroundColor,
  getBorderWidth: getBorderWidth,
  toBorderColor: toBorderColor,
  toTextColor: toTextColor,
  sizeToFontSize: sizeToFontSize
};

var borderRadius = Relude_Globals.$great$great(fromFloat, Relude_Option.getOrThrow, 8.0);

var borderWidth = Relude_Globals.$great$great(fromFloat, Relude_Option.getOrThrow, 1.0);

var Size$3 = {};

var FocusState$1 = {};

function error(param_0) {
  return /* Error */{
          _0: param_0
        };
}

function getError(errorMessage) {
  if (typeof errorMessage === "number") {
    return Relude_Option.none;
  } else {
    return Relude_Option.pure(errorMessage._0);
  }
}

function parseValidationStatus(validationStatus) {
  return Relude_Option.fold(/* Waiting */0, (function (param) {
                return Relude_Result.fold(error, (function (param) {
                              return Relude_Globals.$$const(/* Success */1, param);
                            }), param);
              }), validationStatus);
}

var ValidationStatus = {
  waiting: /* Waiting */0,
  success: /* Success */1,
  error: error,
  getError: getError,
  parseValidationStatus: parseValidationStatus
};

function isDisabled(param) {
  if (param) {
    return false;
  } else {
    return true;
  }
}

function useInput(disabled, onBlurOpt, onFocusOpt, validationStatus) {
  var onBlur = onBlurOpt !== undefined ? onBlurOpt : Relude_IO.pure(undefined);
  var onFocus = onFocusOpt !== undefined ? onFocusOpt : (function (param) {
        return Relude_Globals.$great$great((function (prim) {
                      
                    }), Relude_IO.pure, param);
      });
  var match = ReactIO.useState(function (param) {
        return /* Blurred */0;
      });
  var setFocusState = match[1];
  var validationStatus$1 = parseValidationStatus(validationStatus);
  var styleType = disabled ? /* Disabled */0 : /* Enabled */({
        _0: match[0],
        _1: validationStatus$1
      });
  return {
          onBlur: Relude_IO.flatMap((function (param) {
                  return onBlur;
                }), Curry._1(setFocusState, /* Blurred */0)),
          onFocus: (function (focusEvent) {
              return Relude_IO.flatMap((function (param) {
                            return Curry._1(onFocus, focusEvent);
                          }), Curry._1(setFocusState, /* Focused */1));
            }),
          styleType: styleType
        };
}

function sizeToHorizontalPadding(param) {
  return Relude_Globals.$great$great((function (param) {
                switch (param) {
                  case /* Compact */0 :
                      return 4.0;
                  case /* Small */1 :
                      return 10.0;
                  case /* Medium */2 :
                      return 14.0;
                  case /* Large */3 :
                      return 18.0;
                  
                }
              }), fromFloat$1, param);
}

function sizeToVerticalPadding(param) {
  return Relude_Globals.$great$great((function (param) {
                switch (param) {
                  case /* Compact */0 :
                      return 4.0;
                  case /* Small */1 :
                      return 6.0;
                  case /* Medium */2 :
                      return 8.0;
                  case /* Large */3 :
                      return 10.0;
                  
                }
              }), fromFloat$1, param);
}

function sizeToFontSize$1(param) {
  if (param !== 1) {
    if (param !== 0) {
      return /* Large */4;
    } else {
      return /* Small */2;
    }
  } else {
    return /* Medium */3;
  }
}

function sizeToTitleFontSize(param) {
  if (param >= 2) {
    return /* Medium */3;
  } else {
    return /* Small */2;
  }
}

function getTitleColor(param, param$1) {
  return Relude_Function.curry2((function (param) {
                if (param[0]) {
                  var match = param[1];
                  if (!match) {
                    return {
                            TAG: /* White */7,
                            _0: /* Light */2
                          };
                  }
                  if (!match._0 && typeof match._1 === "number") {
                    return {
                            TAG: /* White */7,
                            _0: /* Light */2
                          };
                  }
                  
                } else {
                  var match$1 = param[1];
                  if (!match$1) {
                    return {
                            TAG: /* Grey */2,
                            _0: /* Dark */1
                          };
                  }
                  if (!match$1._0 && typeof match$1._1 === "number") {
                    return {
                            TAG: /* Grey */2,
                            _0: /* Dark */1
                          };
                  }
                  
                }
                if (param[1]._0) {
                  return {
                          TAG: /* Teal */6,
                          _0: /* Medium */2
                        };
                } else {
                  return {
                          TAG: /* Red */5,
                          _0: /* Medium */2
                        };
                }
              }), param, param$1);
}

function getBorderSize(param) {
  return Relude_Globals.$great$great((function (param) {
                if (param) {
                  if (param._0) {
                    return 2.0;
                  } else if (typeof param._1 === "number") {
                    return 1.0;
                  } else {
                    return 2.0;
                  }
                } else {
                  return 1.0;
                }
              }), fromFloat$1, param);
}

function getTextColor(param) {
  if (param) {
    return {
            TAG: /* Grey */2,
            _0: /* Dark */1
          };
  } else {
    return {
            TAG: /* Grey */2,
            _0: /* Light */3
          };
  }
}

function getHintColor(param) {
  if (!param) {
    return {
            TAG: /* Grey */2,
            _0: /* Light */3
          };
  }
  var match = param._1;
  if (typeof match === "number") {
    if (match !== 0) {
      return {
              TAG: /* Green */1,
              _0: /* Dark */1
            };
    } else {
      return {
              TAG: /* Grey */2,
              _0: /* Dark */1
            };
    }
  } else {
    return {
            TAG: /* Red */5,
            _0: /* Medium */2
          };
  }
}

function getBorderColor(param, param$1) {
  return Relude_Function.curry2((function (param) {
                if (param[0]) {
                  var match = param[1];
                  if (!match) {
                    return {
                            TAG: /* Grey */2,
                            _0: /* Medium */2
                          };
                  }
                  if (!match._0 && typeof match._1 === "number") {
                    return {
                            TAG: /* White */7,
                            _0: /* Light */2
                          };
                  }
                  
                } else {
                  var match$1 = param[1];
                  if (!match$1) {
                    return {
                            TAG: /* Grey */2,
                            _0: /* Light */3
                          };
                  }
                  if (!match$1._0 && typeof match$1._1 === "number") {
                    return {
                            TAG: /* Grey */2,
                            _0: /* Light */3
                          };
                  }
                  
                }
                if (param[1]._0) {
                  return {
                          TAG: /* Teal */6,
                          _0: /* Medium */2
                        };
                } else {
                  return {
                          TAG: /* Red */5,
                          _0: /* Medium */2
                        };
                }
              }), param, param$1);
}

function getBackgroundColor(param) {
  if (param) {
    if (param._0) {
      return {
              TAG: /* Teal */6,
              _0: /* Lightest */4
            };
    } else if (typeof param._1 === "number") {
      return {
              TAG: /* White */7,
              _0: /* Light */2
            };
    } else {
      return {
              TAG: /* Red */5,
              _0: /* Lightest */4
            };
    }
  } else {
    return {
            TAG: /* White */7,
            _0: /* Light */2
          };
  }
}

function sizeToIconSize(param) {
  if (param !== 2) {
    if (param >= 3) {
      return /* Large */3;
    } else {
      return /* Small */1;
    }
  } else {
    return /* Medium */2;
  }
}

var Input = {
  borderRadius: borderRadius,
  borderWidth: borderWidth,
  Size: Size$3,
  FocusState: FocusState$1,
  ValidationStatus: ValidationStatus,
  isDisabled: isDisabled,
  useInput: useInput,
  sizeToHorizontalPadding: sizeToHorizontalPadding,
  sizeToVerticalPadding: sizeToVerticalPadding,
  sizeToFontSize: sizeToFontSize$1,
  sizeToTitleFontSize: sizeToTitleFontSize,
  getTitleColor: getTitleColor,
  getBorderSize: getBorderSize,
  getTextColor: getTextColor,
  getHintColor: getHintColor,
  getBorderColor: getBorderColor,
  getBackgroundColor: getBackgroundColor,
  sizeToIconSize: sizeToIconSize
};

function toPoint$2(param) {
  return Relude_Globals.$great$great((function (param) {
                switch (param) {
                  case /* Zero */0 :
                      return 0.0;
                  case /* XXSmall */1 :
                      return 2.0;
                  case /* XSmall */2 :
                      return 4.0;
                  case /* Small */3 :
                      return 8.0;
                  case /* Medium */4 :
                      return 16.0;
                  case /* Large */5 :
                      return 24.0;
                  case /* XLarge */6 :
                      return 32.0;
                  case /* XXLarge */7 :
                      return 40.0;
                  case /* XXXLarge */8 :
                      return 48.0;
                  case /* XXXXLarge */9 :
                      return 56.0;
                  
                }
              }), fromFloat$1, param);
}

var Spacing = {
  toPoint: toPoint$2
};

function SpacingConverter(C) {
  var toSpacing = function (param) {
    return Relude_Globals.$great$great(toPoint$2, C.pointToSpacing, param);
  };
  var xxSmall = Relude_Globals.$great$great(toPoint$2, C.pointToSpacing, /* XXSmall */1);
  var xSmall = Relude_Globals.$great$great(toPoint$2, C.pointToSpacing, /* XSmall */2);
  var small = Relude_Globals.$great$great(toPoint$2, C.pointToSpacing, /* Small */3);
  var medium = Relude_Globals.$great$great(toPoint$2, C.pointToSpacing, /* Medium */4);
  var large = Relude_Globals.$great$great(toPoint$2, C.pointToSpacing, /* Large */5);
  var xLarge = Relude_Globals.$great$great(toPoint$2, C.pointToSpacing, /* XLarge */6);
  var xxLarge = Relude_Globals.$great$great(toPoint$2, C.pointToSpacing, /* XXLarge */7);
  var xxxLarge = Relude_Globals.$great$great(toPoint$2, C.pointToSpacing, /* XXXLarge */8);
  var xxxxLarge = Relude_Globals.$great$great(toPoint$2, C.pointToSpacing, /* XXXXLarge */9);
  return {
          toSpacing: toSpacing,
          xxSmall: xxSmall,
          xSmall: xSmall,
          small: small,
          medium: medium,
          large: large,
          xLarge: xLarge,
          xxLarge: xxLarge,
          xxxLarge: xxxLarge,
          xxxxLarge: xxxxLarge
        };
}

exports.Point = Point;
exports.Theme = Theme;
exports.Box = Box;
exports.Typography = Typography;
exports.Elevation = Elevation;
exports.ColorRawValue = ColorRawValue;
exports.Color = Color;
exports.ColorConverter = ColorConverter;
exports.Icon = Icon;
exports.$$Image = $$Image;
exports.Button = Button$1;
exports.Input = Input;
exports.Spacing = Spacing;
exports.SpacingConverter = SpacingConverter;
/* include Not a pure module */
